module.exports = __webpack_public_path__ + "img/switzerland-external-causes-female.59644566.png";